import { useCallback } from "react";

import { useGlobalData } from "@/providers";

export function useGetCountryName() {
  const { countries } = useGlobalData();

  return useCallback(
    (countryId: string): string | undefined => {
      const country = countries?.find((country) => country.id === countryId);
      return country?.name;
    },
    [countries]
  );
}
